export type TProductType = 'addon' | '' | 'fee-addon' | 'plan' | 'shop-addon';
export enum EProductType {
    empty = '',
    addon = 'addon',
    feeAddon = 'fee-addon',
    plan = 'plan',
    shopAddon = 'shop-addon',
}
